const companiesDefaultState = {
  companies: [],
  selectedProjectId: 0,
};

export default (state=companiesDefaultState, action) => {
  switch (action.type) {
    case 'SET_COMPANIES' :
      return {
        ...state,
        companies: action.companies
      };
    case 'SET_SELECTED_PROJECT_ID':
      return {
        ...state,
        selectedProjectId: action.projectId,
      };
    default:
      return state;
  }
};
